import { ColorTextLink, ColorCostcoBlue, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
const VARIANTS = {
  PRIMARY: "primary",
  PRIMARY_ALTERNATE: "primary-alternate",
  TERTIARY: "tertiary",
  TERTIARY_DARK_BG: "tertiary-dark-bg",
  GHOST: "ghost",
  GHOST_DARK_BG: "ghost-dark-bg",
  SECONDARY: "secondary",
  TEXT_BUTTON: "text-button",
  TEXT_BUTTON_ALTERNATE: "text-button-alternate",
  TEXT_BUTTON_OUT_OF_STOCK: "text-button-out-of-stock"
};
const LOADING_BUTTON_COLOR_MAP = {
  [VARIANTS.PRIMARY]: ColorWhite,
  [VARIANTS.PRIMARY_ALTERNATE]: ColorWhite,
  [VARIANTS.TERTIARY]: ColorCostcoBlue,
  [VARIANTS.TERTIARY_DARK_BG]: ColorWhite,
  [VARIANTS.GHOST]: ColorCostcoBlue,
  [VARIANTS.GHOST_DARK_BG]: ColorWhite,
  [VARIANTS.SECONDARY]: ColorCostcoBlue,
  [VARIANTS.TEXT_BUTTON]: ColorTextLink,
  [VARIANTS.TEXT_BUTTON_ALTERNATE]: ColorTextLink,
  [VARIANTS.TEXT_BUTTON_OUT_OF_STOCK]: ColorTextLink
};
const LOADING_POSITION = ["start", "end", "center"];
export {
  LOADING_BUTTON_COLOR_MAP,
  LOADING_POSITION,
  VARIANTS
};
